import { Directive } from '@angular/core';
import { IfSagepayCloudPaymentActiveDirectiveDef } from '@df/module-sagepay';

@Directive({
    selector: '[ifSagepayCloudPaymentActive]',
    standalone: true
})
export class IfSagepayCloudPaymentActiveDirective extends IfSagepayCloudPaymentActiveDirectiveDef {}
